<template>
    <div id="app" style="background-color: #f1f1f1">
        <v-app style="background-color: #f1f1f1" class="container--fluid">
            <header v-if="isDesktop()">
                <section>
                    <a href="https://www.free.sn/" id="logo" target="_blank">
                        <img class="ml-5 pl-5 mt-2" src="./assets/logofree.png" width="70" alt="logo">
                    </a>
                    <nav>
                        <ul>
                            <li><a href="/">Accueil</a></li>
                            <li style="color: #000000"><a href="https://www.free.sn/free" target="_blank">Particuliers</a></li>
                            <li><a href="https://www.free.sn/free-business" target="_blank">Free Business</a></li>
                            <li><a href="https://www.free.sn/free-money" target="_blank">Free money</a></li>
                            <li><a href="https://www.free.sn/free-boutique" target="_blank">Nos devices</a></li>
                            <li><a href="https://www.free.sn/propos-de-free-senegal" target="_blank">A propos</a></li>
                        </ul>
                    </nav>
                </section>
            </header>

            <div v-if="isMobile()">
                <v-toolbar flat color="white">
                    <v-toolbar-title class="headline">
                        <a href="https://www.free.sn" target="_blank">
                            <img width="50" src="./assets/logofreemobile.png" alt="">
                        </a>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon color="#C82528" @click.native.stop="leftMenu = !leftMenu">list</v-icon>
                </v-toolbar>

                <v-layout fill-height>
                    <v-navigation-drawer id="menu" clipped app right stateless v-model="leftMenu">
                        <v-list>
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon @click.native.stop="leftMenu = !leftMenu">close</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile class="mt-3">
                                <nav class="ml-5">

                                   <ul>
                                        <li><a href="/">Accueil</a></li>
                                        <li><a href="https://www.free.sn/free" target="_blank">Particuliers</a></li>
                                        <li><a href="https://www.free.sn/free-business" target="_blank">Free Business</a></li>
                                        <li><a href="https://www.free.sn/free-money" target="_blank">Free money</a></li>
                                        <li><a href="https://www.free.sn/free-boutique" target="_blank">Nos devices</a></li>
                                        <li><a href="https://www.free.sn/propos-de-free-senegal" target="_blank">A propos</a></li>
                                    </ul>
                                </nav>
                            </v-list-tile>
                        </v-list>
                    </v-navigation-drawer>

                </v-layout>
            </div>

            <v-container style="background-color:#fff;height: 100%!important" fluid>
                <notifications />
                <router-view></router-view>
            </v-container>

            <v-footer height="75" style="background-color: #f1f1f1">
                <v-layout align-center justify-center>
                    <span class="powered font-weight-light" style="color: black">Powered by <span style="font-weight: bold">eConnect
                        <button v-if="isDesktop()" @click="openPDF()" style="color: #C82528" href="#">CGV</button>
                        <a v-if="isMobile()" style="color: #C82528" href="/cgv_mobile" target="_blank">CGV</a>
                    </span></span>
                </v-layout>

                <v-dialog v-model="PDF" width="800" v-if="isDesktop">
                    <v-card class="border-radius scroll">
                        <v-layout class="border-radius grey lighten-3 column ml-3 mr-3 mt-3 mb-3">
                            <v-container>
                                <img src="./assets/cgv/CGV-1.png" alt="cgv" width="100%">
                                <img src="./assets/cgv/CGV-2.png" alt="cgv" width="100%">
                            </v-container>
                        </v-layout>
                    </v-card>
                </v-dialog>
            </v-footer>
  
        </v-app>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                toCgv:{
                    to: '/cgv_mobile', target:'_blank'
                },
                PDF: false,
                leftMenu: false,
                sideNav: false,
                dialog: false,
            }
        },
        methods: {
            openPDF: function (){
                this.PDF = true
            },
            isMobile: function () {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },
            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>
<style scoped>

  #menu {
        border-bottom-left-radius: 8px!important;
        color: #fff!important;
        transition: 0.8s!important;
        padding: 0!important;
        width: 100%!important;
        height: 100%!important;
        margin: 0!important;
    }
    .powered { color: rgb(151, 151, 151)!important; }

    .mtncredit ::-webkit-input-placeholder {
        text-align: center!important;
        font-size: 22px!important;
    }

    .mtncredit input {
        text-align: center!important;
        font-size: 22px!important;
    }

    * {
        text-decoration: none!important;
        list-style: none!important;
    }
    section {
        /* //height: 100%!important; */
        width: 100%!important;
        margin: 0px auto!important;
        display: table!important;
        position: absolute!important;
        overflow: hidden!important;
        background-color: #fff!important;
    }
    header {
        width: 100%!important;
        display: table!important;
        background-color: #fff!important;
    }
    #logo {
        float: left!important;
        padding: 20px 20px!important;
    }
    nav {
        width: auto!important;
        float: right!important;
    }
    nav ul {
        display: table!important;
        float: right!important;
        padding-right: 20px!important;
    }
    nav ul li {
        float: left!important;
        padding-top: 10px!important;
    }
    nav ul li:last-child {
        padding-right: 0px!important;
    }
    nav ul li a {
        color: #000000!important;
        font-size: 16px!important;
        padding: 15px 25px!important;
        display: inline-block!important;
        transition: all 0.5s ease 0s!important;
    }
    nav ul li a:hover {
        color: #C82528!important;
        transition: all 0.5s ease 0s!important;
    }
    .scroll{
        max-height: 500px!important;
        overflow-y: auto!important;
    }

    .border-radius{
        border-radius: 30px!important;
    }


</style>
